import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { Form, SimpleTextField, useSettings } from 'app/main/components';
import { type ModelType } from 'app/main/components/hooks/useModel';

interface ChangeLoginMailDialogProps {
	userMail: string;
	sendChange: ModelType['sendChange'];
}

export const showChangeLoginMailDialog = (props: ChangeLoginMailDialogProps) =>
	openDialog({
		children: <ChangeLoginMailDialog {...props} />,
		maxWidth: 'xs',
		onClose: () => {}
	});

export default function ChangeLoginMailDialog({ userMail, sendChange }: ChangeLoginMailDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const [newLoginMail, setNewLoginMail] = React.useState<string | null>(userMail);

	const close = () => {
		dispatch(closeDialog());
	};

	return (
		<Form
			id="changeLoginEmail"
			onSubmit={() => {
				sendChange('user_mail', newLoginMail);
				close();
			}}
		>
			<DialogTitle>{t('DIALOG_LOGIN_MAIL_TITLE')}</DialogTitle>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid size={12}>
						<Typography>{t('DIALOG_LOGIN_MAIL_DESCRIPTION1')}</Typography>
					</Grid>
					<Grid size={12}>
						<Typography fontWeight={500}>{t('DIALOG_LOGIN_MAIL_DESCRIPTION2')}</Typography>
					</Grid>
					<Grid size={12}>
						<SimpleTextField
							name="user_mail"
							label={t('DIALOG_LOGIN_EMAIL_FIELD')}
							value={newLoginMail}
							isEdit
							sendChange={(_name, newValue) => setNewLoginMail(newValue)}
							required
							validations={{ isEmail: true }}
							validationErrors={{
								isDefaultRequiredValue: t('ERROR_TEXT_REQUIRED'),
								isEmail: t('ERROR_TEXT_EMAIL')
							}}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={close}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="changeLoginEmail">
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</Form>
	);
}
